export default __webpack_public_path__ + "static/autopilot-f35be0a10b16b0f80011f357523aff9b.svg";